import middlewares from '@/middlewares/http-common';
import { handleResponse, handleRetryError } from './ResponseHandlers.js';
import retry from 'p-retry';
import { Logger } from '../middlewares/sentry.js';

export const shouldRetryHandler = (error) => {
  const parsedError = JSON.parse(error.message);
  const errorStatus = Number(parsedError.status);

  if (errorStatus >= 500) {
    Logger.error(error);
    return false;
  }

  return error.attemptNumber < 2;
};

export const handleGetBlob = async (url, params) => {
  return await retry(
    async () => {
      try {
        const resp = await middlewares.httpGet.get(url, {
          params,
        });

        return await handleResponse(resp);
      } catch (err) {
        await handleRetryError(err);
      }
    },
    {
      retries: 2,
      minTimeout: 2000,
      shouldRetry: (error) => shouldRetryHandler(error),
    },
  );
};

export const handleGet = async (url, params, headers = {}) => {
  const result = await retry(
    async () => {
      try {
        const resp = await middlewares.httpJson.get(url, {
          headers: headers,
          params,
        });

        return await handleResponse(resp);
      } catch (err) {
        await handleRetryError(err);
      }
    },
    {
      retries: 2,
      minTimeout: 2000,
      shouldRetry: (error) => shouldRetryHandler(error),
    },
  );

  return result;
};

export const handlePost = async (url, data, headers = {}) => {
  return await retry(
    async () => {
      try {
        const resp = await middlewares.httpJson.post(url, data, {
          headers,
        });

        return handleResponse(resp);
      } catch (err) {
        await handleRetryError(err);
      }
    },
    {
      retries: 2,
      minTimeout: 2000,
      shouldRetry: (error) => shouldRetryHandler(error),
    },
  );
};
